import SectionHeading from "@/pages/home/components/SectionHeading";
import { reversalItems } from "@/mocks/digData";

export default function ReversalSection() {
  return (
    <section id="reversal" className="scroll-mt-24 py-16 md:py-24 bg-foreground-950">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-8">
        <SectionHeading
          light
          eyebrow="PLOT TWIST"
          title="后续反转与当事人发声"
          desc="把最初流传的说法和后来出现的新信息并列摆在一起，前后对照看清楚口径是怎么变的，再看当事人自己怎么说。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 lg:grid-cols-3 gap-5 md:gap-6">
          {reversalItems.map((item) => (
            <article
              key={item.id}
              className="flex flex-col rounded-lg border border-background-50/15 bg-background-950/50 p-5 md:p-6"
            >
              <div className="flex items-center justify-between gap-3">
                <span
                  className={`px-2.5 py-1 rounded-full text-xs border ${
                    item.stage === "已更正"
                      ? "border-accent-400/60 text-accent-300 bg-accent-500/10"
                      : "border-secondary-400/60 text-secondary-300 bg-secondary-500/10"
                  }`}
                >
                  {item.stage}
                </span>
                <span className="w-8 h-8 flex items-center justify-center rounded-full bg-background-50/10">
                  <i className="ri-arrow-left-right-line text-primary-300" />
                </span>
              </div>

              <h3 className="mt-4 font-heading text-lg md:text-xl font-bold text-background-50">
                {item.title}
              </h3>

              <div className="mt-4 space-y-3 flex-1">
                <div className="rounded-md border border-background-50/10 bg-background-50/5 p-3">
                  <p className="flex items-center gap-1.5 text-xs text-background-300">
                    <i className="ri-time-line" />
                    最初说法
                  </p>
                  <p className="mt-1.5 text-sm text-background-200 leading-relaxed">{item.before}</p>
                </div>
                <div className="flex justify-center">
                  <i className="ri-arrow-down-double-line text-primary-400 text-xl" />
                </div>
                <div className="rounded-md border border-primary-500/30 bg-primary-500/10 p-3">
                  <p className="flex items-center gap-1.5 text-xs text-primary-200">
                    <i className="ri-refresh-line" />
                    更新后
                  </p>
                  <p className="mt-1.5 text-sm text-background-100 leading-relaxed">{item.after}</p>
                </div>
              </div>

              <blockquote className="mt-5 rounded-md border-l-2 border-primary-400 bg-background-50/5 px-4 py-3">
                <p className="text-sm text-background-100 leading-relaxed">“{item.quote}”</p>
                <footer className="mt-2 flex items-center gap-1.5 text-xs text-secondary-300">
                  <i className="ri-mic-line" />
                  {item.quoteBy}
                </footer>
              </blockquote>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}